import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Check } from 'lucide-react';

export default function PaymentSuccess() {
  const { user, fetchUser } = useAuth();

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="payment-success-page">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Check className="w-8 h-8 text-green-600" />
        </div>
        <h1 className="text-3xl font-serif font-bold text-slate-900 mb-4">Payment Successful!</h1>
        <p className="text-slate-600 mb-8">Your subscription has been activated. You now have full access to all case studies.</p>
        <div className="flex flex-col gap-3">
          <Link to="/cases" className="px-6 py-3 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-all" data-testid="browse-cases-link">
            Browse Case Library
          </Link>
          <Link to="/dashboard" className="px-6 py-3 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-100 transition-all" data-testid="go-dashboard-link">
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
